<template>
    <basic-container id="energyDeptSetting20210429">
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
                  
            <template slot="menuLeft" slot-scope="scope">
                <el-button type="primary"
                           size="small"
                           @click="applyFor">新增
                </el-button>
            </template>
            <template slot="menu" slot-scope="scope">
                <el-button type="text"
                           size="small"
                           icon="el-icon-view"
                           @click="openViewDialog(scope.row)">查看
                </el-button>
                <el-button type="text"
                           size="small"
                           icon="el-icon-edit"
                           @click="openEditDialog(scope.row)">编辑
                </el-button>
                 <el-button type="text"
                           size="small"
                           icon="el-icon-delete"
                           @click="rowDel(scope.row)">删除
                </el-button>
            </template>
            <template slot="projectIdSearch">
                 <el-select v-model="searchForm.projectId" placeholder="请选择">
                    <el-option
                        v-for="item in projectList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                </el-select>
            </template>
             <template slot="deptIdSearch">
                 <avue-input-tree  
                 v-model="searchForm.deptId" 
                 :props='{ label: "title", value: "id" }'
                 placeholder="请选择" 
                 type="tree" :dic="deptList"></avue-input-tree>
        
            </template>
           
            
        </avue-crud>
        <recipientsFrom ref="recipientsFrom" @onLoad="onLoad"></recipientsFrom>
    </basic-container>
</template>

<script>
    // import {mapGetters} from "vuex";
    
    import {
        getProjectList,
        getDict,
        } from "@/api/crmedical/warehouse/index.js";
    import {
        getList,
        treeByIds,
        remove,
        } from "@/api/crmedical/energy/energy-consumption/index.js"
    import recipientsFrom from './form';
    export default {
        components:{
            recipientsFrom
        },
        
        data() {
            return {
                form: {},
                valuetime:'',
                query: {},
                money:0,
                loading: false,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                onloadFlag:false,//为了避免第一次请求必须在projecid赋值后进行
                selectionList: [],
                searchForm:{
                    projectId:'',
                    warehouseId:'',
                    people:''
                },
                deptList:[],//科室
                projectList:[],//项目名称
                warehouseList:[],//仓库名称
                statusList:[],//状态
                option: {
                    
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    addBtn:false,
                    searchShow: true,
                    searchMenuSpan: 4,
                    // searchBtnIcon:'none',
                    border: true,
                    index: true,
                    emptyBtn:true,
                    emptyBtnText:'重置',
                    // emptyBtnIcon:'none',
                    indexLabel: '序号',
                    viewBtn: false,
                    selection: false,
                    dialogClickModal: false,
                    textAlign:'center',
                    headerAlign: 'center',
                    align: 'center',
                    delBtn:false,
                    editBtn:false,
                    column: [
                                
                                {
                                    label: "项目名称",
                                    prop: "projectId",
                                    dicUrl: '/api/v4ward/project/getProjectList',
                                    search: true,
                                    type:'select',
                                    searchslot:true,
                                    dataType: 'string',
                                    dicData:[],
                                    props:{
                                        label:'name',
                                        value:'id'
                                    },
                                    value:'',
                                    rules: [{
                                        required: true,
                                        message: "请选择项目",
                                        trigger: "change"
                                    }]
                                },
                                 {
                                    label: "部门名称",
                                    prop: "deptId",
                                    search: true,
                                    type: "tree",
                                    viewDisplay: false,
                                    searchslot:true,
                                    hide: true,
                                    // dataType:'string',
                                    dicData:[],
                                    
                                    // dicUrl: 'api/v4ward/dept/treeByIds',
                                    props: { label: 'title', value: 'key' },
                                    rules: [{
                                    required: true,
                                    message: "请选择科室",
                                    trigger: "change"
                                    }]
                                },

                                {
                                    label: "科室名称",
                                    prop: "deptName",
                                  
                                },
                                 {
                                    label: "仪表类型",
                                    prop: "meterType",
                                    type: 'select',
                                    searchSpan:5,
                                    search: true,
                                    dataType: 'number',
                                    dicUrl: 'api/blade-system/dict/dictionary?code=meter_type',
                                    props: { label: 'dictValue', value: 'dictKey' },
                                    rules: [{
                                    required: true,
                                    message: "请选择仪表类型",
                                    trigger: "blur"
                                    }]
                                },
                                
                                {
                                    label: "能耗指标",
                                    prop: "energyTarget",
                                   
                                    
                                    searchSpan:5,
                                   
                                    type:'select',
                                    
                                },
                               
                          
                               
                         ]
                },
                data: [],
                userlist: [],
        value: [],
        list: [],
        loading: false,
     
      }
            
        },
        created() {
            console.log("created===>");
                this.fetchData();
              
        },
        methods: {

            async fetchData() {
                this.pageLoading = true;                
                try {
                    //projectList
                    const resProjectList = await getProjectList();
                    this.projectList = resProjectList.data;

                    
                    this.searchForm.projectId = this.projectList[0]? this.projectList[0].id:'';
                   
                    //warehouseList
                    const deptList = await treeByIds();
                    console.log(deptList.data)
                    this.deptList = deptList.data;
                    let deptcolumn = this.findObject(this.option.column,'deptId');
                   
                    deptcolumn.dicData = deptList.data;
                    console.log(12345678)
                     console.log(deptcolumn)
                    this.searchForm.deptId = deptList.data[0]?deptList.data[0].id:'';
                    
                    this.onloadFlag = true;
                    this.onLoad();
             
                } catch (err) {
                    console.log("err==>", err);
                }
                this.pageLoading = false;
                },
            // 打开申请表单 新增
            applyFor(){
                let dicData = {
                    projectIdDictDataList:this.projectList,
                    projectId:this.searchForm.projectId,
                    deptList:this.deptList,

                }
                this.$refs.recipientsFrom.openDialog({type:'add',dicData:dicData});
            },
            // 打开编辑弹窗
            openEditDialog(row){
                console.log(row)
                let dicData = {
                    projectIdDictDataList:this.projectList,
                    projectId:this.searchForm.projectId,
                    deptList:this.deptList,

                }
                this.$refs.recipientsFrom.openDialog({type:'edit',dicData:dicData,data:row});
            },
            // 打开查看弹窗
            openViewDialog(row){
                // debugger;
                let dicData = {
                    projectIdDictDataList:this.projectList,
                    projectId:this.searchForm.projectId,
                    deptList:this.deptList,

                }
                this.$refs.recipientsFrom.openDialog({type:'view',dicData:dicData,data:row});
            },

            // 申请人模糊搜索
             remoteMethod(query) {
                if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.options = this.list.filter(item => {
                    return item.label.toLowerCase()
                        .indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
                } else {
                this.options = [];
                }
            },
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            cleanForm() {
                for(let key in this.form){
                    this.form[key] = null;
                }
            },
            searchReset() {

                this.searchForm.projectId = this.projectList[0].id;
                this.searchForm.deptId = this.deptList[0].id;
                this.query = {};
                this.$refs.crud.toggleSelection();
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                if(!this.onloadFlag){
                    return;
                }
                page = page || this.page;
                this.query.projectId = this.searchForm.projectId || '';
                this.query.deptId =  this.searchForm.deptId || '';
                this.loading = true;
                console.log(this.query)
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                   
                    this.data = data.records;
                    this.loading = false;
                    // this.selectionClear();
                });
               
            }
        }
    };
</script>

<style>
#energyDeptSetting20210429 .el-icon-circle-close{
        display: none;
        background-color: #f00;
        color: #f00;
        opacity: 0;
}
</style>
